const t = {
  public: () => ({ auth: "public" }),
  authenticated: () => ({ auth: "required" }),
  requirePrivileges: (...e) => ({
    auth: "required",
    requiredPrivileges: e
  })
};
export {
  t as authMeta
};
//# sourceMappingURL=procedure-meta.js.map
